"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ensureEndsWith = void 0;
/**
 * Ensure that provided value ends with provided string
 */
const ensureEndsWith = (value, mustEndsWith) => value.endsWith(mustEndsWith) ? value : `${value}${mustEndsWith}`;
exports.ensureEndsWith = ensureEndsWith;